import {
  faSchool,
  faBriefcase,
  faMasksTheater,
  faHandHeart,
  faHouseFloodWater,
  faBinBottlesRecycle,
  faPotFood,
  faHeartPulse,
  faHouse,
  faChildReaching,
  faCirclePause,
} from '@fortawesome/pro-light-svg-icons';

export const getImpactSummaryIcons = (value?: string) => {
  switch (value) {
    case 'Arts and Culture':
      return faMasksTheater;
    case 'Community and Economic Development':
      return faBriefcase;
    case 'Disaster Management':
      return faHouseFloodWater;
    case 'Diversity, Equity, Inclusion, and Accessibility':
      return faCirclePause;
    case 'Environment and Sustainability':
      return faBinBottlesRecycle;
    case 'Education':
      return faSchool;
    case 'Food Security':
      return faPotFood;
    case 'Health':
      return faHeartPulse;
    case 'Housing and Human Services':
      return faHouse;
    case 'Youth':
      return faChildReaching;
    default:
      return faHandHeart;
  }
};

export const logicModalImpactSummary = {
  'Affordable Housing': 'People',
  'Arts and Culture': 'Beneficiaries',
  'Basic Needs': 'People',
  'Civic Engagement, Advocacy, and Systems Change': 'Participants',
  'Community and Neighborhood Revitalization': 'People',
  'Community and School-Based Meal Programs': 'Participants',
  'Community Economic Development': 'People',
  'Community Resiliency': 'People',
  'Disaster Preparation': 'People',
  'Disaster Response': 'People',
  'Diversity, Equity, Inclusion, and Accessibility': 'People',
  'Early Childhood Development': 'Youth',
  'Economic Security': 'People',
  'Education: K-12 Classroom': 'Students',
  'Education: Out-of-School Programming': 'Students',
  'Education: Post-secondary, Career Development': 'Students',
  'Educational Access': 'Students',
  'Educator Training': 'Students',
  'Emergency Housing': 'People',
  'Environmental Conservation': 'People',
  'Food Distribution': 'People',
  'Gender Equity': 'People',
  'Growing and Harvesting': 'People',
  Health: 'People',
  'Health Education and Behavior Change': 'People',
  'Health Systems, Policy, Advocacy, and Research': 'People',
  'Human Rights': 'People',
  'Positive Youth Development': 'Youth',
  'Racial Justice': 'People',
  'Recreation and Play': 'Participants',
  'Recycling and Waste': 'People',
  'Scholarships and Fellowships': 'Students',
  'Small Business and Non-Profit Support': 'People',
  'STEM Education: K-12 Classroom': 'Students',
  'STEM education/career development programs': 'Students',
  'STEM Education: Out-of-School Programming': 'Students',
  'STEM Education: Post-secondary, Career Development': 'Students',
  'Sustainable Agriculture': 'People',
  'Sustainable Business Practices': 'People',
  'Transit and Mobility': 'People',
  'Water Access, Sanitation, and Hygiene': 'People',
  'Wildlife Conservation': 'Animals',
  'Workforce Development': 'Participants',
};
